import React from "react";
import { IMG_URl } from "src/common/img_url";
import Visibility from "../utils/Visibility";
import { indexStore } from "src/store/indexStore";
import { useTranslation } from "react-i18next";
import { AlertDialogs } from "../Dialgos/Alter-Daylogs";
import EditItemsModel from "../pages/items/EditItemsModel";
import { Skeleton } from "../ui/skeleton";
import { userTypes } from "src/enums/usersTpes";
import { Switch } from "../ui/switch";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Button } from "../ui/button";
import { Edit, Trash2, Package, Image as ImageIcon, EyeOff } from "lucide-react";
import { Badge } from "../ui/badge";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";

export function ProductCard(props) {
  const { t } = useTranslation();
  const {
    nameLang,
    description,
    deleteItemsFunction,
    setItem,
    hiddenItemsFunction,
    unavailableItemsFunction,
  } = indexStore();
  
  const onDeleteItem = (id) => {
    deleteItemsFunction(id);
  };
  
  const editItem = (element) => {
    setItem(element);
  };
  
  const onHidden = (id) => {
    hiddenItemsFunction(id);
  };
  
  const onUnavailable = (id) => {
    unavailableItemsFunction(id);
  };

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20 h-full flex flex-col" key={props.id}>
      <CardHeader className="p-0 relative">
        <div className="relative aspect-square w-full overflow-hidden bg-muted">
          {props.image ? (
            <img
              src={`${IMG_URl}${props.image}`}
              alt={props[nameLang] || t("gloabl.item")}
              className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-muted to-muted/50">
              <ImageIcon className="w-16 h-16 text-muted-foreground/30" />
            </div>
          )}
          <div className="absolute top-2 right-2 flex gap-1 flex-wrap">
            <ProductTags item={props} t={t} />
          </div>
        </div>
      </CardHeader>

      <CardContent className="p-4 flex flex-col flex-1">
        <div className="mb-3">
          <h3 className="text-lg font-bold text-foreground line-clamp-1 mb-1">
            {props[nameLang] || t("gloabl.item")}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2 min-h-[2.5rem]">
            {props[description] || ""}
          </p>
        </div>

        <div className="mb-4 p-3 bg-gradient-to-br from-green-50 to-green-100/50 dark:from-green-950/30 dark:to-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <UAEDirhamIcon className="w-4 h-4 text-green-600" />
              <span className="text-xs text-muted-foreground">{t("gloabl.price")}</span>
            </div>
            <div className="flex items-center gap-2">
              {props.price_offer > 0 && (
                <span className="text-sm line-through text-muted-foreground">
                  {Number(props.price).toFixed(2)}
                </span>
              )}
              <span className={`text-lg font-bold ${props.price_offer > 0 ? "text-green-600" : "text-green-600"}`}>
                {Number(props.price_offer > 0 ? props.price_offer : props.price).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className="mt-auto">
          <Visibility
            visible={
              localStorage.getItem("role") === userTypes.ADMIN ||
              localStorage.getItem("role") === userTypes.DATAMANAGER
            }
          >
            <div className="flex gap-2 pt-4 border-t">
              <EditItemsModel
                trigger={
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex-1 gap-2"
                    onClick={() => editItem(props)}
                  >
                    <Edit className="w-4 h-4" />
                    {t("gloabl.edit")}
                  </Button>
                }
              />
              <AlertDialogs
                trigger={
                  <Button
                    variant="destructive"
                    size="sm"
                    className="gap-2"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                }
                variant="icon"
                onClickOk={() => onDeleteItem(props.id)}
                description={<span>{t("gloabl.deleteMessage")}</span>}
                title={`${t("gloabl.delete")} ${t("gloabl.item")}`}
              />
            </div>
          </Visibility>

          <Visibility
            visible={localStorage.getItem("role") === userTypes.CALLCENTER}
          >
            <div className="pt-4 border-t space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <EyeOff className="w-4 h-4 text-muted-foreground" />
                  <label className="text-sm font-medium text-foreground">
                    {t("gloabl.hidden")}
                  </label>
                </div>
                <Switch
                  dir="ltr"
                  checked={props.hidden}
                  onCheckedChange={() => onHidden(props.id)}
                />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Package className="w-4 h-4 text-muted-foreground" />
                  <label className="text-sm font-medium text-foreground">
                    {t("gloabl.unavailable")}
                  </label>
                </div>
                <Switch
                  dir="ltr"
                  checked={props.unavailable}
                  onCheckedChange={() => onUnavailable(props.id)}
                />
              </div>
            </div>
          </Visibility>
        </div>
      </CardContent>
    </Card>
  );
}

const ProductTags = ({ item, t }) => {
  return (
    <Visibility
      visible={item.new || item.unavailable || item.popular || item.hidden}
    >
      <div className="flex gap-1 flex-wrap">
        <Visibility visible={item.new === true}>
          <Badge className="bg-green-500 text-white border-0">
            {t("gloabl.new")}
          </Badge>
        </Visibility>
        <Visibility visible={item.popular === true}>
          <Badge className="bg-yellow-500 text-white border-0">
            {t("gloabl.popular")}
          </Badge>
        </Visibility>
        <Visibility visible={item.unavailable === true}>
          <Badge className="bg-red-500 text-white border-0">
            {t("gloabl.unavailable")}
          </Badge>
        </Visibility>
        <Visibility visible={item.hidden === true}>
          <Badge className="bg-gray-800 text-white border-0 dark:bg-gray-700">
            {t("gloabl.hidden")}
          </Badge>
        </Visibility>
      </div>
    </Visibility>
  );
};

export const ProductCardLoading = () => (
  <Card className="overflow-hidden border-2">
    <CardHeader className="p-0">
      <Skeleton className="aspect-square w-full" />
    </CardHeader>
    <CardContent className="p-4">
      <div className="mb-3">
        <Skeleton className="h-5 w-3/4 mb-2" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6 mt-1" />
      </div>
      <Skeleton className="w-full h-16 rounded-lg mb-4" />
      <div className="flex gap-2 pt-4 border-t">
        <Skeleton className="h-9 flex-1" />
        <Skeleton className="w-9 h-9" />
      </div>
    </CardContent>
  </Card>
);
